import React from 'react';

const ItemList = ({ items, onChange, onRemove }) => {
  return (
    <div id="items-container">
      {items.map((item, index) => (
        <div className="item-row" key={index}>
          <div className="form-group">
            <label htmlFor={`item-desc-${index}`}>Description:</label>
            <input 
              type="text" 
              id={`item-desc-${index}`}
              value={item.description}
              onChange={(e) => onChange(index, 'description', e.target.value)}
              placeholder="Item description"
            />
          </div>
          <div className="form-group">
            <label htmlFor={`item-hsn-${index}`}>HSN Code:</label>
            <input 
              type="text" 
              id={`item-hsn-${index}`}
              value={item.hsn}
              onChange={(e) => onChange(index, 'hsn', e.target.value)}
              placeholder="Enter HSN code"
            />
          </div>
          <div className="form-group">
            <label htmlFor={`item-qty-${index}`}>Quantity:</label>
            <input 
              type="number" 
              id={`item-qty-${index}`}
              value={item.qty}
              onChange={(e) => onChange(index, 'qty', e.target.value)}
              placeholder="Quantity"
              min="1"
            />
          </div>
          <div className="form-group">
            <label htmlFor={`item-unit-${index}`}>Unit:</label>
            <input 
              type="text" 
              id={`item-unit-${index}`}
              value={item.unit}
              onChange={(e) => onChange(index, 'unit', e.target.value)}
              placeholder="Unit (Nos, kg, etc)"
            />
          </div>
          <div className="form-group">
            <label htmlFor={`item-rate-${index}`}>Rate/unit:</label>
            <input 
              type="number" 
              id={`item-rate-${index}`}
              value={item.rate}
              onChange={(e) => onChange(index, 'rate', e.target.value)}
              placeholder="Rate per unit"
              min="0"
              step="0.01"
            />
          </div>
          {items.length > 1 && (
            <button className="remove-item" onClick={() => onRemove(index)}>Remove</button>
          )}
        </div>
      ))}
    </div>
  );
};

export default ItemList;